import type { DeliveryStatusType } from '@/types/domain/photo/valueObjects/deliveryStatus';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';
import { DELIVERY_STATUS_TYPE } from '@/types/domain/photo/valueObjects/deliveryStatus';

export class DeliveryStatus extends PrimitiveValueObject<DeliveryStatusType> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: DeliveryStatusType): DeliveryStatus {
    return new DeliveryStatus(value);
  }

  /** ラベル */
  static get label(): string {
    return '配送状態';
  }

  /** キー */
  static get key(): string {
    return 'deliveryStatus';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** リスト */
  static get list(): {
    /** ID */
    id: string,
    /** 名前 */
    name: string,
  }[] {
    const items = [];
    for (let i = 0; i < DELIVERY_STATUS_TYPE.length; i += 1) {
      items.push({
        id: DELIVERY_STATUS_TYPE[i],
        name: DELIVERY_STATUS_TYPE[i],
      });
    }
    return items;
  }
}
